import { Option } from 'react-select/src/filters';
import { TFunction } from 'react-i18next';
import { FetchedOptionType } from '../types/form.types';

const transformLabelsToOptions = (
  options: FetchedOptionType[] | string[],
  t: TFunction
): Option[] => {
  return options.map((option: FetchedOptionType | string) => {
    if (typeof option === 'string') {
      return { value: option, label: t(option), data: undefined };
    }
    return {
      value: option.value,
      label: t(option.value),
      data: { faq_tag: option.faq_tag }
    };
  });
};

const FormUtils = { transformLabelsToOptions };
export default FormUtils;
